import * as React from 'react'

import { Flex } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'
import { TTextFontSize } from '~ui/styleGuide/fontStyles'

type TProps = NoChildren & {
  /**
   * translated label of the cart sum
   */
  sumLabel: string
  /**
   * total sum of the cart, with the currency abbreviation
   */
  cartSum: string
}

const FONT_STYLE: PropsOf<typeof Text>['fontStyle'] = `bold`
export const CART_ITEM_TOTAL_FONT_SIZE: TTextFontSize = `m18`

export const CartItemTotal: React.FC<TProps> = ({ cartSum, sumLabel }) => {
  return (
    <Flex justifyContent={`space-between`}>
      <Text fontStyle={FONT_STYLE} fontSize={CART_ITEM_TOTAL_FONT_SIZE}>
        {sumLabel}
      </Text>
      <Text fontStyle={FONT_STYLE} fontSize={CART_ITEM_TOTAL_FONT_SIZE}>
        {cartSum}
      </Text>
    </Flex>
  )
}
